















































































































































































import { Component, Mixins, Watch } from 'vue-property-decorator';
import { Actions } from '@/ts/store/Constants';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';
import SelectedItems from '@/components/Admin/Layout/SelectedItems.vue';
import LanguagesDropDown from '@/components/DropDowns/LanguagesDropDown.vue';
import Multiselect from 'vue-multiselect';

@Component({
    components: {
        SelectedItems,
        LanguagesDropDown,
        Multiselect,
    },
})
export default class EditDocumentForm extends Mixins(InputFieldMethods) {
    public currentLanguage = 'en';
    public documentsCategories: any = [];
    public languages: any = [];
    public documentTitles: any = [];
    public documentDescriptions: any = [];
    public documentFiles: any = [];
    public insideDropFileButton: boolean = false;

    constructor() {
        super();
    }

    get getDocumentData(): any {
        return this.$store.getters['Documents/getCurrentDocument'];
    }

    get getLocalizationKey() {
        return this.$store.getters['Localization/getLocalizationKey'];
    }

    get categories(): any {
        const categories = this.$store.getters['Categories/getDocumentCategories'];

        const categoriesOptions = categories.map((category: any, index: number) => {
            const targetedTranslation = category.translations.find((translation: any) => translation.language.key === this.getLocalizationKey);
            return {id: category.id, title: targetedTranslation.title};
        });

        return categoriesOptions;
    }

    get activeDocument(): any {
        return this.documentFiles.find((file: any) => file.lang === this.currentLanguage);
    }

    @Watch('getLocalizationKey')
    public getLocalizationKeyChanged() {
        const categories = this.$store.getters['Categories/getDocumentCategories'];

        this.documentsCategories.map((category: any) => {
            const targetedCategory = categories.find((targCategory: any) => targCategory.id === category.id);

            if (typeof targetedCategory !== 'undefined') {
                const targetedTranslation = targetedCategory.translations.find((translation: any) => translation.language.key === this.getLocalizationKey);

                if (typeof targetedTranslation !== 'undefined') {
                    category.title = targetedTranslation.title;
                }
            }
        });
    }

    public setTranslatableFields(languages: any) {
        languages.forEach((language: any) => {
            this.addTranslation(language);
        });
    }

    public addTranslation(addedLanguage: any) {
        const document     = this.getDocumentData;
        const content      = document.translations.find((translation: any) => translation.language_id === addedLanguage.id);
        const media        = document.media.find((mediaObj: any) => mediaObj.language_id === addedLanguage.id);
        const checkIfExist = this.documentTitles.find((title: any) => title.lang === addedLanguage.key);

        if (typeof checkIfExist === 'undefined') {
            this.documentTitles.push({ lang: addedLanguage.key, content: typeof content === 'undefined' ? '' : content.title });
            this.documentDescriptions.push({ lang: addedLanguage.key, content: typeof content === 'undefined' ? '' : content.content });
            this.documentFiles.push({ lang: addedLanguage.key, content: typeof media === 'undefined' ? null : media });
        }
    }

    public removeTranslation(deletedLanguage: any) {
        this.documentTitles       = this.documentTitles.filter((title: any) => title.lang !== deletedLanguage.key);
        this.documentDescriptions = this.documentDescriptions.filter((title: any) => title.lang !== deletedLanguage.key);
        this.documentFiles        = this.documentFiles.filter((file: any) => file.lang !== deletedLanguage.key);
    }

    public setCurrentLanguage(selectedLanguage: any) {
        this.currentLanguage = selectedLanguage.key;
    }

    public openFileInput(lang: any) {
        document.getElementById(`documentFileInput${lang}`).click();
    }

    public addDocumentFile(documentLang: any) {
        const element      = (document.getElementById(`documentFileInput${documentLang}`) as HTMLInputElement);
        const documentFile = this.documentFiles.find((document: any) => document.lang === documentLang);

        documentFile.content = (element.files.length === 0) ? '' : (element.files[0] as File);
    }

    public onDrop(event: any) {
        if (event.dataTransfer.files[0].type === 'application/pdf') {
            const element = (document.getElementById(`documentFileInput${this.currentLanguage}`) as HTMLInputElement);
            element.files = event.dataTransfer.files;
            this.addDocumentFile(this.currentLanguage);
        }
        this.insideDropFileButton = false;
    }

    public dragover(event: any) {
        event.preventDefault();

        this.insideDropFileButton = true;
    }

    public dragleave(event: any) {
        this.insideDropFileButton = false;
    }

    public previewMedia(id: number) {
        this.$store.dispatch(Actions.FETCH_DOCUMENT_MEDIA_PREVIEW, id);
    }

    public removeDocumentFile(lang: string) {
        const documentObj   = this.documentFiles.find((file: any) => file.lang === this.currentLanguage);
        documentObj.content = null;
        const element       = (document.getElementById(`documentFileInput${documentObj.lang}`) as HTMLInputElement);

        element.type = 'text';
        element.type = 'file';
    }

    public updateDocument() {
        const document = this.getDocumentData;

        this.$validator.validate().then((valid) => {
            if (valid) {
                this.$store.dispatch(Actions.EDIT_DOCUMENT, {
                    id: document.id,
                    titles: this.documentTitles,
                    descriptions: this.documentDescriptions,
                    files: this.documentFiles,
                    categories: this.documentsCategories.map((category: any, index: number) => category.id),
                    internal: document.internal,
                });
            }
        });
    }

    public cancel() {
        this.$store.dispatch(Actions.HIDE_FORM);
    }

    public created() {
        this.$store.dispatch(Actions.FETCH_DOCUMENT_CATEGORIES);

        if (this.getDocumentData !== null) {
            this.documentsCategories = this.categories.filter((category: any) => this.getDocumentData.categories.includes(category.id));
            this.languages = this.getDocumentData.translations.map((translation: any) => translation.language_id);
        }
    }
}
